module.exports = __webpack_public_path__ + "img/papel-toalha-bobina.ee31d6fa.png";